type Song = {
  title: string;
  type: string;
  lyrics: string;
  meaning: string;
  occasion: string;
  youtubeId?: string | null;
};

const SongCard = ({
  song,
  darkMode = false,
}: {
  song: Song;
  darkMode?: boolean;
}) => {
  return (
    <div
      className={`${
        darkMode ? "bg-gray-800 border border-gray-700" : "bg-white"
      } rounded-xl shadow p-4 hover:shadow-lg transition-shadow`}
    >
      <div className="flex justify-between items-start mb-2">
        <div
          className={`text-xl font-bold ${
            darkMode ? "text-orange-200" : "text-orange-800"
          }`}
        >
          {song.title}
        </div>
        <span
          className={`border text-xs px-2 py-1 rounded ${
            darkMode
              ? "border-orange-900 text-orange-200"
              : "border-orange-300 text-orange-700"
          }`}
        >
          {song.type}
        </span>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        <div className="space-y-4">
          <div>
            <div
              className={`font-semibold mb-1 ${
                darkMode ? "text-gray-200" : "text-gray-700"
              }`}
            >
              Lirik:
            </div>
            <div
              className={`${
                darkMode ? "bg-gray-700" : "bg-orange-50"
              } p-3 rounded-lg`}
            >
              <pre
                className={`${
                  darkMode ? "text-gray-200" : "text-gray-700"
                } text-sm whitespace-pre-line font-serif leading-relaxed`}
              >
                {song.lyrics}
              </pre>
            </div>
          </div>
          <div>
            <div
              className={`font-semibold mb-1 ${
                darkMode ? "text-gray-200" : "text-gray-700"
              }`}
            >
              Makna:
            </div>
            <div
              className={`${
                darkMode ? "text-gray-300" : "text-gray-600"
              } text-sm`}
            >
              {song.meaning}
            </div>
          </div>
          <div>
            <div
              className={`font-semibold mb-1 ${
                darkMode ? "text-gray-200" : "text-gray-700"
              }`}
            >
              Acara:
            </div>
            <span
              className={`${
                darkMode
                  ? "bg-orange-900 text-orange-200"
                  : "bg-orange-100 text-orange-800"
              } text-xs px-2 py-1 rounded`}
            >
              {song.occasion}
            </span>
          </div>
        </div>
        {song.youtubeId && (
          <div className="space-y-2">
            <div
              className={`font-semibold mb-1 ${
                darkMode ? "text-gray-200" : "text-gray-700"
              }`}
            >
              Video:
            </div>
            <div className="aspect-video rounded-lg overflow-hidden">
              <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${song.youtubeId}`}
                title={`Video ${song.title}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="rounded-lg"
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SongCard;
